import { useFormikContext } from 'formik';
import { FC, useEffect } from 'react';

type EffectProps = {
  onDirtyChanged?: (dirty: boolean) => void;
  onValidityChanged?: (valid: boolean) => void;
};

export const Effect: FC<EffectProps> = ({ onDirtyChanged, onValidityChanged }) => {
  const context = useFormikContext();
  const dirty = context.dirty;
  const valid = context.isValid;

  useEffect(() => {
    onDirtyChanged?.(dirty);
  }, [dirty]);

  useEffect(() => {
    onValidityChanged?.(valid);
  }, [valid]);

  return null;
};
